import {Injectable} from "@angular/core";
import {AccreditationBody, StandardName} from "../../store/state/order.state";
import {Observable} from "rxjs";
import {filter, first, map, mergeMap} from "rxjs/operators";
import {filterIso27701Questions, StandardEstimateQuestions} from "./estimate-questions.resolver";
import {EndpointsProvider} from "../../umbrella-common/endpoints/endpoint-provider.service";
import {orderSelector} from "../../store/state/state.selectors";
import {Store} from "@ngrx/store";
import {AppState} from "../../store/state/app.state";

@Injectable()
export class EstimateQuestionsFetchService {

	constructor(private endpoints: EndpointsProvider, private store: Store<AppState>) {
	}

	fetchEstimateQuestions(): Observable<StandardEstimateQuestions[]> {
		return this.store.select(orderSelector).pipe(
			filter(order => order.clientCountry != null),
			first(),
			map(order => order.products.map(p => p.accreditationBody)),
			mergeMap((accBodies: AccreditationBody[]) => this.endpoints.common.getEstimateQuestions(accBodies)
				.pipe(map(questions => {
					let estimateQuestions = [];
					Object.values(AccreditationBody).forEach(body => {
						if (accBodies.includes(body)) {
							const questionsForAccBody = questions[body];
							const iso27701Questions = questionsForAccBody.find(q => q.standardName == StandardName.ISO_27701);
							iso27701Questions.questions = filterIso27701Questions(iso27701Questions.questions);
							estimateQuestions.push(questionsForAccBody);
						}
					})

					return estimateQuestions.flat();
				})))
		)
	}
}
